import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { RichMarkdownIt } from '../../../components';
import { LogEntry } from '../../../models';
import { useTranslation } from '../../../translations';
import { makeRelativeLogLink, TableQueryOpts } from './query';

interface LogDetailModalProps {
  readonly entry: LogEntry;
  readonly params: TableQueryOpts;
}

export const LogDetailModal: FC<LogDetailModalProps> = ({ entry, params }) => {
  const { ts } = useTranslation();

  return (
    <Modal isOpen>
      <ModalHeader>{ts('details')}</ModalHeader>
      <ModalBody>
        {entry.message && (
          <div>
            <RichMarkdownIt source={entry.message} />
          </div>
        )}
        <div>
          Raw:
          <pre>{JSON.stringify(entry.meta, null, 2)}</pre>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" tag={Link} to={makeRelativeLogLink(params, {}, ['view'])}>
          {ts('common.close')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
